import * as React from "react";
const LoadingFeedbackContext = React.createContext(null);
export default LoadingFeedbackContext;
